<template>
  <div>
    <label for="pi2">HASH (TXID)</label>
    <div class="input-group has-clearable">
      <button
        type="button"
        class="close show text-success"
        aria-label="Close"
        v-clipboard:copy="invoice.txid"
        v-clipboard:success="onCopy"
      >
        <span aria-hidden="true">
          <i class="far fa-clone"></i>
        </span>
      </button>

      <label class="input-group-prepend" for="pi2">
        <span class="input-group-text">
          <i class="far fa-paper-plane"></i>
        </span>
      </label>
      <input type="text" class="form-control" id="pi2" :value="invoice.txid" readonly />
    </div>
    <small v-if="invoice.txid">
      <a
        class="text-warning"
        target="_blank"
        :href="getBlockchainExplorerUrl()"
      >
        <i class="fa fa-link"></i>
        VIEW ON BLOCKCHAIN
      </a>
    </small>
  </div>
</template>

<script>
export default {
  name: "invoice-paid",
  props: {
    invoice: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    getBlockchainExplorerUrl() {
      const currencyName = this.invoice.currency?.name || "";
      const currencyId = this.invoice.currency?.id || this.invoice.currency_id;
      const txid = this.invoice.txid;

      // USDT on BNB Smart Chain (currency_id: 17)
      if (currencyId === 17 || currencyName.includes("BNB") || currencyName.includes("BSC") || currencyName.includes("BEP20")) {
        return `https://bscscan.com/tx/${txid}`;
      }

      // USDT on TRON network (currency_id: 16)
      if (currencyId === 16 || currencyName.includes("TRON") || currencyName.includes("TRC20") || currencyName.includes("USDT")) {
        return `https://tronscan.org/#/transaction/${txid}`;
      }

      // Bitcoin
      if (currencyName.includes("BTC")) {
        return `https://www.blockchain.com/btc/tx/${txid}`;
      }

      // Ethereum or ERC-20 tokens
      if (currencyName.includes("ETH") || currencyName.includes("ERC")) {
        return `https://etherscan.io/tx/${txid}`;
      }

      // Default to Bitcoin explorer
      return `https://www.blockchain.com/btc/tx/${txid}`;
    },
    onCopy() {
      this.$toasted.show("Copied to clippboard!", {
        position: "top-right",
        duration: 5000,
        type: "success",
        closeOnSwipe: true
      });
    }
  }
};
</script>
